import { formatCurrency, type Challan } from '../data/challans';
import styles from './ChallanCard.module.css';

interface ChallanCardProps {
  challan: Challan;
}

export function ChallanCard({ challan }: ChallanCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <div className={styles.meta}>
          <span className={styles.id}>{challan.id}</span>
          <span className={styles.violation}>{challan.violation}</span>
        </div>
        <span
          className={
            challan.status === 'Paid'
              ? `${styles.badge} ${styles.paidBadge}`
              : `${styles.badge} ${styles.unpaidBadge}`
          }
        >
          {challan.status}
        </span>
      </div>

      <div className={styles.row}>
        <div className={styles.amountBlock}>
          <span className={styles.amountLabel}>Amount</span>
          <span className={styles.amount}>{formatCurrency(challan.amount)}</span>
        </div>
        <div className={styles.dueBlock}>
          <span className={styles.dueLabel}>{challan.status === 'Paid' ? 'Paid on' : 'Due by'}</span>
          <span className={styles.dueValue}>
            {challan.status === 'Paid' ? challan.paidOn ?? '-' : challan.dueDate || '-'}
          </span>
        </div>
      </div>
    </div>
  );
}
